import { normalizeStringArray } from "@arti/plan-revision-telemetry";

export { normalizeStringArray };

export function normalizeString(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function extractStringField(
  obj: Record<string, unknown> | null | undefined,
  key: string,
): string | null {
  if (!obj || typeof obj !== "object") {
    return null;
  }
  return normalizeString(obj[key]);
}
